import object_value from './object_value'
import moment from 'moment/moment'

/**
 * group_experiences
 * @param objects
 * @param computed_date_format
 * @returns {*}
 */
export default function group_experiences ({objects, computed_date_format = 'events.0.date'}) {
  console.log('group_experiences - objects:', objects)
  if (!Array.isArray(objects) || objects.length < 1) {
    return false
  }

  let format_date = (date) => {
    return moment(date).utc().isSame(moment(), 'day')
      ? moment(date).utc().format('[Today - ]HH:mm')
      : moment(date).utc().format('DD.MM.YYYY - HH:mm')
  }

  // Add dates
  let experiences_with_dates = []
  for (let object of objects) {
    let date = object_value(object, computed_date_format)
    if (date) {
      let computed_date = moment(date).utc().format()
      object.formatted_date = format_date(computed_date)
      object.computed_date = computed_date
      object.computed_date_getTime = moment(date).utc().valueOf()
    }
    experiences_with_dates.push(object)
  }

  // Sort
  let sort_by_date = (a, b) => a.computed_date_getTime - b.computed_date_getTime
  experiences_with_dates.sort(sort_by_date)

  // Group
  let grouped_experiences = {
    is_today: [],
    is_after: [],
    is_before: []
  }
  let used_today_first = false
  let used_after_first = false
  let used_before_first = false
  for (let experience of experiences_with_dates) {
    let date = object_value(experience, 'computed_date')
    if (date) {
      let is_today = moment(date).utc().isSame(moment(), 'day')
      let is_after = moment(date).utc().isAfter(moment(), 'day')
      let is_before = moment(date).utc().isBefore(moment(), 'day')

      if (is_today) {
        experience.is_today = true
        experience.variant = 'inverted'
        if (!used_today_first) {
          experience.topic = 'Heute'
          used_today_first = true
        }
        grouped_experiences.is_after.push(experience)
      }

      if (is_after) {
        experience.is_after = true
        if (!used_after_first) {
          experience.topic = 'Kommende Erlebnisse'
          used_after_first = true
        }
        grouped_experiences.is_after.push(experience)
      }

      if (is_before) {
        experience.is_before = true
        if (!used_before_first) {
          experience.topic = 'Vergangene Erlebnisse bei den ich teilgenommen habe'
          used_before_first = true
        }
        grouped_experiences.is_before.push(experience)
      }
    }
  }

  return grouped_experiences
}


// WEBPACK FOOTER //
// ./src/api/group_experiences.js